import { defineMessages } from 'react-intl';

const messages = defineMessages({
  formTitle: {
    id: 'Data de Modificação',
    defaultMessage: 'Data de Modificação',
  },
  text: {
    id: 'Texto',
    defaultMessage: 'Texto',
  },
  longDate: {
    id: 'Incluir hora e minutos',
    defaultMessage: 'Incluir hora e minutos',
  },
});

export const modificationDateSchema = (props) => {
  return {
    title: props.intl.formatMessage(messages.formTitle),
    fieldsets: [
      {
        id: 'default',
        title: 'Default',
        fields: ['text', 'long'],
      },
    ],
    properties: {
      text: {
        title: props.intl.formatMessage(messages.formTitle),
        default: 'Dados atualizados em: ',
      },
      long: {
        title: props.intl.formatMessage(messages.longDate),
        type: 'boolean',
        default: false,
      },
    },
    required: ['text'],
  };
};
